import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SG_FETCH_ORG_GROUP } from 'constants/actions';
import { Header, Segment, Loader, Message } from 'semantic-ui-react';
import ListEmployees from './ListEmployees';

const OrganizationDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { orgGroupDetail, loading, error } = useSelector(state => state.groups);

  useEffect(() => {
    if (id) {
      dispatch({ type: SG_FETCH_ORG_GROUP, payload: { id } });
    }
  }, [dispatch, id]);

  let descObj = null;
  if (orgGroupDetail && orgGroupDetail.description) {
    try {
      descObj = JSON.parse(orgGroupDetail.description);
    } catch (e) {
      descObj = null;
    }
  }

  return (
    <div>
      {loading && <Loader active>Loading organization details...</Loader>}
      {error && <Message negative>{error}</Message>}
      {orgGroupDetail && (
        <Segment>
          <Header as="h2">{orgGroupDetail.name}</Header>
          <p><b>ID:</b> {orgGroupDetail.id}</p>
          {descObj ? (
            <>
              {descObj.question && <p><b>Question:</b> {descObj.question}</p>}
              {descObj.subtitle && <p><b>Subtitle:</b> {descObj.subtitle}</p>}
              {descObj.options && Array.isArray(descObj.options) && descObj.options.length > 0 && (
                <div style={{ marginTop: 10 }}>
                  <b>Options:</b>
                  <ul style={{ paddingLeft: 20 }}>
                    {descObj.options.map(opt => (
                      <li key={opt.id} style={{ color: opt.color || undefined }}>
                        {opt.name}
                        {opt.description ? ` - ${opt.description}` : ''}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          ) : (
            orgGroupDetail.description && <p><b>Description:</b> {orgGroupDetail.description}</p>
          )}
        </Segment>
      )}
      {/* Employee list for this organization group */}
      <ListEmployees />
    </div>
  );
};

export default OrganizationDetail;
